import { CONFIG } from '@/core/config';

export function generateMifLink(studyId: string) {
  return `${CONFIG.APPS_SERVER}/admin/study/${studyId}/medical-history/radiologist/embed`;
}

export function generatePreviousStudyReportPdfLink(studyId: string) {
  return `${CONFIG.HI_SERVER}/radiologist/study/${studyId}/latest-pdf-report?viewOnly=True`;
}
